/* eslint-disable */
var $ = window.jQuery = jQuery = require('jquery');
import axios from 'axios';
import toast from '../../services/toast';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'subscription-plan',
  components: {},
  props: [],
  data() {
    return {
      subscriptionPlan: {},
      EditSubscPopup: false,
      EditSubscId: '',
      name: '',
      description: '',
      price: '',
      validity: '',
      submitted: false
    }
  },
  computed: {
    ...mapGetters([
      'getSubscriptionPlanListState',
      'getSubscriptionPlanDetailsState'
    ]),
    getUserSubscription() {
      this.subscriptionPlan = this.$store.getters.getSubscriptionPlanListState.data
      return this.subscriptionPlan
    },
  },
  mounted() {
    this.getUserSubscription
  },
  methods: {
    getUserSubscriptionAgain() {
      this.$store.dispatch('getSubscriptionPlanList').then((res) => {
        this.subscriptionPlan = res.data
      }).catch((err) => {})
    },
    SubscrPlanPopup(id) {
      this.EditSubscId = id
      this.EditSubscPopup = true
      this.$store.dispatch('getSubscriptionPlanDetailsById', {
        id: this.EditSubscId
      }).then((res) => {
        if (res.status == '200' || res.status == '201') {
          this.name = res.data.data.name
          this.description = res.data.data.description
          this.price = res.data.data.price
          this.validity = res.data.data.validity
        }
      }).catch((err) => {})
      return;

    },
    EditSubscPopupClose() {
      this.EditSubscPopup = false
    },
    updateSubscPlanConfirmation() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.name,
            description: this.description,
            price: this.price,
            validity: this.validity
          }
          this.$store.dispatch('updateSubscriptionPlanDetailsById', {
              data: {
                data: data,
                id: this.EditSubscId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.getUserSubscriptionAgain();
                toast.success(res.data.msg);
                this.EditSubscPopup = false
                this.$validator.reset();
              }
            })
            .catch((err) => {})
          return
        }
      });
    }
  },
  watch: {
    getUserSubscription() {
      return this.$store.getters.subscriptionPlan
    },
  }
}